import {
  changeComboValueToEmpty,
  checkDateOrder,
  getDefaultValue,
} from "components/CommonLib/CommonLib";
import ComboBox from "components/LabelInput/ComboBox";
import DatePicker from "components/LabelInput/DatePicker";
import Label from "components/LabelInput/Label";
import SearchComboBox from "components/LabelInput/SearchComboBox";
import TextField from "components/LabelInput/TextField";
import { useEffect, useState } from "react";
import { SearchConditionBox, SearchContainer, SearchRowBox } from "../style";

const DetailCondition = ({
  searchParams,
  setSearchParams,
  branchList,
  resetFlag,
  onClickSearch,
}) => {
  const labelWidth = "5.5rem";
  const textBoxWidth = "17.75rem";
  const textBoxWidthShort = "8.5rem";
  const [isFirstEnterPage, setIsFirstEnterPage] = useState(true);

  // 초기화 시 지점 첫번째 값 세팅
  useEffect(() => {
    if (!isFirstEnterPage && branchList.branch_list[0]) {
      setSearchParams("branch_info", branchList.branch_list[0]);
    }
  }, [resetFlag]);

  useEffect(() => {
    setIsFirstEnterPage(false);
  }, []);

  return (
    <SearchContainer>
      <Label labelText="검색 조건 : 상세" fontWeight="bold" justifyContent="flex-start" />
      <SearchRowBox
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onClickSearch(false, 1);
          }
        }}
      >
        <SearchConditionBox>
          <SearchComboBox
            labelText="지점"
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            marginRight="4rem"
            data={branchList.branch_name_list}
            defaultValue={getDefaultValue("combo", searchParams.branch_info.branch_name)}
            onChangeCallback={(e, v, idx) => {
              setSearchParams("branch_info", branchList.branch_list[idx]);
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <DatePicker
            labelText="연기 신청일"
            labelWidth={labelWidth}
            textBoxWidth={textBoxWidthShort}
            textMarginRight="0rem"
            defaultValue={getDefaultValue("field", searchParams.postpone_reg_date_from)}
            onChangeCallback={(e) => {
              setSearchParams("postpone_reg_date_from", e);
            }}
            onBlur={(e) => {
              if (!checkDateOrder(e, searchParams.postpone_reg_date_to)) {
                setSearchParams("postpone_reg_date_from", "");
              }
            }}
          />
          <DatePicker
            marginLeft="0.12rem"
            marginRight="4rem"
            labelWidth="0.5rem"
            textBoxWidth={textBoxWidthShort}
            textMarginRight="0rem"
            labelMarginRight="0.12rem"
            labelText="~"
            defaultValue={getDefaultValue("field", searchParams.postpone_reg_date_to)}
            onChangeCallback={(e) => {
              setSearchParams("postpone_reg_date_to", e);
            }}
            onBlur={(e) => {
              if (!checkDateOrder(searchParams.postpone_reg_date_from, e)) {
                setSearchParams("postpone_reg_date_to", "");
              }
            }}
          />
        </SearchConditionBox>

        <SearchConditionBox>
          <TextField
            labelText="미등록 경과일"
            labelWidth={labelWidth}
            textMarginRight="0.12rem"
            textBoxWidth={textBoxWidthShort}
            defaultValue={getDefaultValue("field", searchParams.elapsed_date_from)}
            onChangeCallback={(e) => {
              setSearchParams("elapsed_date_from", e);
            }}
          />
          <TextField
            labelText="~"
            labelWidth="0.5rem"
            labelMarginRight="0.12rem"
            textMarginRight="3rem"
            textBoxWidth={textBoxWidthShort}
            defaultValue={getDefaultValue("field", searchParams.elapsed_date_to)}
            onChangeCallback={(e) => {
              setSearchParams("elapsed_date_to", e);
            }}
          />
        </SearchConditionBox>
      </SearchRowBox>

      {/* Lane 2 */}
      <SearchRowBox>
        <SearchConditionBox>
          <DatePicker
            // id="mbshp_date_from"
            labelText="서류 제출 기한"
            labelWidth={labelWidth}
            textBoxWidth={textBoxWidthShort}
            textMarginRight="0rem"
            defaultValue={getDefaultValue("field", searchParams.doc_due_date_from)}
            onChangeCallback={(e) => {
              setSearchParams("doc_due_date_from", e);
            }}
            onBlur={(e) => {
              if (!checkDateOrder(e, searchParams.doc_due_date_to)) {
                setSearchParams("doc_due_date_from", "");
              }
            }}
          />
          <DatePicker
            marginLeft="0.12rem"
            labelWidth="0.5rem"
            textBoxWidth={textBoxWidthShort}
            textMarginRight="0rem"
            labelMarginRight="0.12rem"
            labelText="~"
            defaultValue={getDefaultValue("field", searchParams.doc_due_date_to)}
            onChangeCallback={(e) => {
              setSearchParams("doc_due_date_to", e);
            }}
            onBlur={(e) => {
              if (!checkDateOrder(searchParams.doc_due_date_from, e)) {
                setSearchParams("doc_due_date_to", "");
              }
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <ComboBox
            labelText="서류 제출 상태"
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            data={["전체", "제출", "미등록"]}
            defaultValue={getDefaultValue("combo", searchParams.apply_doc)}
            onChangeCallback={(e) => {
              changeComboValueToEmpty(setSearchParams, "apply_doc", e);
            }}
          />
        </SearchConditionBox>
        <SearchConditionBox>
          <ComboBox
            labelText="승인 상태"
            labelWidth={labelWidth}
            comboItemWidth={textBoxWidth}
            data={["전체", "승인대기", "승인", "거부"]}
            defaultValue={getDefaultValue("combo", searchParams.approve_status)}
            onChangeCallback={(e) => {
              changeComboValueToEmpty(setSearchParams, "approve_status", e);
            }}
          />
        </SearchConditionBox>
      </SearchRowBox>
    </SearchContainer>
  );
};
export default DetailCondition;
